import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, makeStyles } from '@material-ui/core';
import LogoLink from '#web-components/components/Navbar/components/LogoLink';
import NavbarContainer from '#web-components/components/Navbar';
import LogoIcon from 'components/LogoImage';
import styles from './Navbar.styles';

const useStyles = makeStyles(styles, { name: 'Navbar' });

interface NavBarProps {
  disableBackground?: boolean
}

const Navbar: React.FC<NavBarProps> = ({ disableBackground }) => {
  const classes = useStyles();
  const { t } = useTranslation('text');
  return (
    <NavbarContainer disableBackground={disableBackground}>
      <Box className={classes.box}>
        <LogoLink
          direction="left"
          homePath="/"
          appTitle={t('appTitle')}
          logoIcon={<LogoIcon />}
          navLinkComponent={RouterLink}
        />
      </Box>
    </NavbarContainer>
  );
};

export default Navbar;
